import { List, Map as ImmutableMap, fromJS } from 'immutable';
import * as SearchFields from 'SalesContentIndexUI/data/constants/SearchFields';
import SearchFilterRecord from 'SalesContentIndexUI/data/records/SearchFilterRecord';
const filter = field => values => SearchFilterRecord({
  field,
  values: values.reduce((valueList, value) => value ? valueList.push(value) : valueList, List())
});
const SearchFilterMap = fromJS(SearchFields).reduce((filterMap, field) => filterMap.set(field, filter(field)), ImmutableMap());
export default ((filterKey, ...values) => SearchFilterMap.get(filterKey)(values));